<div class="row mt-3" *ngIf="!isViewVehicleDetail && vehicleList && vehicleList.length>0">
  <div class="col-12">
    <b>{{vehicleList.length}}&nbsp;</b>
    <span>vehicle result<span *ngIf="vehicleList.length > 1">s</span></span>
  </div>
  <div class="col-12 mt-3 table-responsive no-gutter">
    <table class="table table-striped tbl-scrollable">
      <thead class="thead-light">
        <tr>
          <!-- <th scope="col"></th> -->
          <!-- <th scope="col">VIN</th> -->
          <!-- Typeahead search field:
            <th scope="col">
            <ng-template #rt let-r="result" let-t="term">
              <ngb-highlight [result]="r.vin" [term]="t"></ngb-highlight>
            </ng-template>
            <input id="typeahead-vin-template" type="text" class="form-control type-ahead-search" placeholder="VIN"
              (selectItem)="onVehicleSelected($event)" [(ngModel)]="searchVin" [ngbTypeahead]="searchVehicle"
              [resultTemplate]="rt" [inputFormatter]="formatter" [editable]='true'
            />
          </th> -->
          <th scope="col" width="7%" class="text-center">
            <button class="btn btn-outline-danger py-0 delete-button" [disabled]="selectedVehicles.length < 1"
              (click)="onDeleteVehicles()"><i class="fa fa-trash"></i></button>
          </th>
          <th width="7%"></th>
          <th scope="col" width="15%">VIN</th>
          <th scope="col" width="11%">Make</th>
          <th scope="col" width="11%">Model</th>
          <th scope="col" width="9%">Year</th>
          <th scope="col" width="11%">Status</th>
          <th scope="col" width="17%">Enrollment Status</th>
          <th scope="col" width="12%">Enrollment Eligible</th>
        </tr>
      </thead>
      <tbody class="max-height-57">
        <tr *ngFor="let vehicle of vehicleList; let i = index" class="pointer">
          <th scope="row" width="7%" class="text-center pr-0">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" name="checkbox" class="custom-control-input"
                [checked]="isVehicleSelected(vehicle.vin)"
                (change)="onVehicleSelectionChange($event.target.checked, vehicle)" id="vehicle_search_{{i}}"
                [disabled]="vehicle.status === 'DELETED'">
              <label class="custom-control-label" for="vehicle_search_{{i}}"></label>
            </div>
          </th>
          <td width="7%" class="pr-0 text-center" (click)="vehicleSelected(vehicle)">
            <img class="vehicle-image-sm" src="{{getVehicleLogo(vehicle)}}" alt="{{vehicle.model}}" />
          </td>
          <td width="15%" scope="row" (click)="vehicleSelected(vehicle)">{{vehicle.vin}}</td>
          <td width="11%" scope="row" (click)="vehicleSelected(vehicle)">{{vehicle.make}}</td>
          <td width="11%" (click)="vehicleSelected(vehicle)"> {{vehicle.model}}</td>
          <td width="9%" (click)="vehicleSelected(vehicle)"> {{vehicle.year}}</td>
          <td width="11%" (click)="vehicleSelected(vehicle)">
            <i [ngClass]="{'ACTIVE':'fa fa-check-circle text-success', 'ENROLLED':'fa fa-check-circle text-success', 'INACTIVE':'fa fa-exclamation-circle text-danger',
            'ASSIGNED':'fa fa-minus-circle text-warning', 'PENDING':'fa fa-minus-circle text-warning', 'ORDERED':'fa fa-exclamation-circle text-danger', 'DELIVERED':'fa fa-exclamation-circle text-danger', 'DELETED':'fa fa-exclamation-circle text-danger'}[vehicle.status]"></i>
            {{vehicle.status | customText}}</td>
          <td width="17%" [ngClass]="vehicle.enrollmentStatus ? '': 'text-center'" (click)="vehicleSelected(vehicle)">
            <span *ngIf="vehicle.enrollmentStatus; else valueNotAvailable">
              {{getVehicleEnrollmentStatus(vehicle) | customText}}
            </span>
          </td>
          <td width="12%" class="text-center" (click)="vehicleSelected(vehicle)">
            <span *ngIf="utilService.isNmacAccount(authService.loggedInUser.accountId) else noNmac">
              Yes
            </span>
            <ng-template #noNmac>
              <span
                *ngIf="vehicle.enrollmentEligibility == true && vehicle.enrollmentReady == true else enrollmentConditionFalse">Yes</span>
              <ng-template #enrollmentConditionFalse>
                No
              </ng-template>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
    <ng-template #valueNotAvailable>
      <span>-</span>
    </ng-template>
  </div>
</div>

<div class="row mt-3" *ngIf="isViewVehicleDetail">
  <div class="col-12">
    <app-view-vehicle-detail [vehicleData]="selectedVehicle" (closeEmitter)="closeVehicleDetailClicked($event)">
    </app-view-vehicle-detail>
  </div>
</div>

<app-review-vehicles [vehicles]="selectedVehicles" [reviewVehiclesHeader]="reviewVehicleModalMessages.header"
[reviewVehiclesMessage]="reviewVehicleModalMessages.message" [reviewVehiclesNote]="reviewVehicleModalMessages.note"
(closeEmitter)="resetSelectedVehicles()" (saveEmitter)="reviewVehiclesSubmit($event)"></app-review-vehicles>